/**
 * CompanyHeadGate · route guard restricting a page to the sales company head only.
 *
 * Layered on top of ModuleGate (which only checks permissions): the Book of business page is not a
 * permission — it's a single named person. Non-head users are redirected to the sales dashboard.
 * The backend independently 403s the underlying endpoint, so this is UX, not the security boundary.
 */
import { Navigate } from 'react-router-dom'
import { useAuthStore } from '@/stores/auth-store'
import { isCompanyHead } from './constants'

export function CompanyHeadGate({ children }: { children: React.ReactNode }) {
  const email = useAuthStore((s) => s.user?.email)
  if (!isCompanyHead(email)) return <Navigate to="/sales/dashboard" replace />
  return <>{children}</>
}
